'use client'

import { useCallback } from 'react'
import { useSession } from 'session/src/hooks/useSession'

import { updateNotificationsService } from '../services/updateNotificationsService'

export const useUpdateNotifications = () => {
	const { token } = useSession()

	const updateNotifications = useCallback(
		async (id: string | null) => {
			await updateNotificationsService({ id, token })
		},
		[token]
	)

	return {
		updateNotifications,
	}
}
